<template>
  <MoleculesModal custom-width="max-w-[330px] md:max-w-[382px]" :on-close="props.close" :should-show-modal="props.isOpen">
    <img alt="" class="mb-4 w-full" src="@/assets/img/parts/wabunka-cvc-info.svg" />
  </MoleculesModal>
</template>

<script lang="ts" setup>
interface Props {
  isOpen: boolean;
  close: () => void;
}

const props = defineProps<Props>();
</script>
